import { SET_SHOW_SHARE_AND_DOWNLOAD_MODAL } from './../const';

export default (showShareAndDownloadModal) => {
  return {
    type: SET_SHOW_SHARE_AND_DOWNLOAD_MODAL,
    showShareAndDownloadModal: showShareAndDownloadModal
  }
};
